/**
 * API MANAGEMENT FOR GROOT
**/

export async function fetchAPI(url, token, options={}) {
    const headers = options.headers = options.headers || {};
    if(options.data && typeof options.data == "object") {
        options.headers['Content-Type'] = "application/json";
        options.body = JSON.stringify(options.data);
        delete options.data;
    }

    headers.Authorization = `Auth ${token}`;

    const response = await fetch(url, options);
    return response;
}
